import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Amount } from '../../../templates/Amount';

export const PeriodicNewTermAmount: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/PeriodicNewTermAmount.${label}.${locale}.json`)}>
      <PeriodicNewTermAmountComponent />
    </I18nProvider>
  );
};

export const PeriodicNewTermAmountComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();
  const { state } = useMeterReadingsFlow();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.PeriodicNewTermAmount'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Amount
      label={t('periodicNewTermAmount.singleAmountLabel')}
      title={t('periodicNewTermAmount.title')}
      content={t('periodicNewTermAmount.content')}
      buttonHref={t('periodicNewTermAmount.buttonLink.href')}
      buttonText={t('periodicNewTermAmount.buttonLink.text')}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('periodicNewTermAmount.imageSrc')}`,
        },
      }}
    />
  );
};
